import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { checkBrokerLoginThunk, fetchBrokerList, setBrokerPurposeThunk } from '@store/slices/brokerSlice';
import { fetchHolidays, fetchSpecialSessions } from '@store/slices/marketSlice';
import { BROKER_SLUGS } from '@/pages/broker-login/brokerConfig';
import TopNavbar from '@/components/navigation/TopNavbar';
import './MainLayout.scss';

const MainLayout = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((s) => s.auth.isLoggedIn);
  const brokers = useSelector((s) => s.broker.list);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(checkBrokerLoginThunk());
      dispatch(fetchBrokerList());
      dispatch(fetchHolidays("nse,nfo"));
      dispatch(fetchSpecialSessions());
    }
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    if (brokers?.length > 0) {
      const unpurposed = brokers.filter(
        (b) => b.type !== BROKER_SLUGS.PAPERTRADING && (!b.purpose || b.purpose === ""),
      );
      if (unpurposed.length > 0) {
        unpurposed.forEach((b) => {
          dispatch(setBrokerPurposeThunk({ brokerId: b.id, purpose: 'terminal' }));
        });
      }
    }
  }, [brokers, dispatch]);


  return (
    <div className="main-layout">
      <TopNavbar />
      <main className="main-layout__content">
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
